// extracted by mini-css-extract-plugin
export default {"Welcome":"Welcome_Welcome__+b9SF","logo":"Welcome_logo__DS8ir"};